import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PostsBulkActionsSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PostsBulkActions" */ "@circle-react/components/SettingsApp/PostsBulkActions"
    ),
);

export const PostsBulkActionsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <PostsBulkActionsSettingsComponent />
  </Suspense>
);
